import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CandidateSummary } from '../../../../candidates/models/candidate-summary';
import { AuthenticationResult } from '../../../../shared/models/authentication-result';
import { UiStateStore } from '../../../../shared/store/ui-state-store.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-dashboard-employer-manage-candidates',
  templateUrl: './dashboard-manage-candidates.component.html',
  styleUrls: ['./dashboard-manage-candidates.component.scss']
})
export class DashboardEmployerManageCandidatesComponent implements OnInit {

  public user: AuthenticationResult = null;
  subscriptions: Subscription[] = [];

  _candidates: BehaviorSubject<CandidateSummary[]> = new BehaviorSubject<CandidateSummary[]>([]);
  public candidates: Observable<CandidateSummary[]> = this._candidates.asObservable();
  _totalPageCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public totalPageCount: Observable<number> = this._totalPageCount.asObservable();

  constructor(private uiStore: UiStateStore,
    public dataService: DataService) { }

  ngOnInit() {
    let userSubscription = this.uiStore.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }

      this.user = user;

      this.dataService.getBookmarkedCandidates(this.user.accountId, 1).subscribe(searchResult => {
        this._candidates.next(searchResult.result);
        this._totalPageCount.next(searchResult.pageCount);
      });
    });

    this.subscriptions.push(userSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onPagerValueChanged(args): void {
    let pageNumber = args.number;
    this.dataService.getBookmarkedCandidates(this.user.accountId, pageNumber).subscribe(searchResult => {
      this._candidates.next(searchResult.result);
      this._totalPageCount.next(searchResult.pageCount);
    });
  }

}
